import type { OfferingMedia } from "./types";

export type OfferingMediaKind = "image" | "video";

export function getSortedOfferingMedia(
  media?: OfferingMedia[],
): OfferingMedia[] {
  return (media ?? [])
    .filter((item) => item.url)
    .map((item, index) => ({ item, index }))
    .sort((a, b) => {
      const aOrder = a.item.sort_order ?? Number.MAX_SAFE_INTEGER;
      const bOrder = b.item.sort_order ?? Number.MAX_SAFE_INTEGER;
      if (aOrder !== bOrder) return aOrder - bOrder;
      return a.index - b.index;
    })
    .map(({ item }) => item);
}

// Offerings only ever carry image or video media (enforced upstream by
// after-internal's ALLOWED_OFFERING_MEDIA_MIME_TYPES). Anything else is
// treated as an image so a broken asset falls through to the <img> onError
// handler rather than rendering a player for non-video content.
export function getOfferingMediaKind(media: OfferingMedia): OfferingMediaKind {
  const mimeType = media.mime_type?.toLowerCase() ?? "";
  if (mimeType.startsWith("video/")) return "video";
  return "image";
}

export function getOfferingMediaLabel(
  media: OfferingMedia,
  serviceName: string,
  index: number,
): string {
  return (
    media.alt?.trim() ||
    media.caption?.trim() ||
    `${serviceName} media ${index + 1}`
  );
}
